import { type ComponentStyleConfig } from '@chakra-ui/react'

export const Progress: ComponentStyleConfig = {
  baseStyle: {
    filledTrack: {
      bg: 'primary.teal.60',
    },
  },
}
